"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _ChangeRequest = _interopRequireDefault(require("dataparcels/ChangeRequest"));

var _react = require("react");

// $FlowFixMe - useState is a named export of react
// $FlowFixMe - useState is a named export of react
var _default = function _default(_ref) {
  var onSubmit = _ref.onSubmit,
      onReset = _ref.onReset;
  // buffer ref is used to allow handleChange functions from past renders
  // to always affect the same buffer reference
  var bufferRef = (0, _react.useRef)(); // buffer state is used to update the component
  // whenever the buffer changes so that the buffer
  // can be passed down as props

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      bufferState = _useState2[0],
      setBufferState = _useState2[1];

  var updateBufferState = function updateBufferState() {
    return setBufferState(bufferRef.current);
  };

  var push = function push(changeRequest) {
    bufferRef.current = bufferRef.current ? bufferRef.current.merge(changeRequest) : changeRequest;
    updateBufferState();
  };

  var reset = function reset() {
    bufferRef.current = null;
    updateBufferState();
    onReset();
  };

  var submit = function submit() {
    if (bufferRef.current) {
      var _changeRequest = bufferRef.current;
      onSubmit(_changeRequest);
      bufferRef.current = null;
      updateBufferState();
    } else {
      onSubmit(new _ChangeRequest.default());
    }
  };

  var unshift = function unshift(changeRequest) {
    bufferRef.current = bufferRef.current ? changeRequest.merge(bufferRef.current) : changeRequest;
    updateBufferState();
  };

  return {
    bufferState: bufferState,
    push: push,
    reset: reset,
    submit: submit,
    unshift: unshift
  };
};

exports.default = _default;